import { BlockStack } from '@shopify/polaris';
import { DatePickerShow } from './components/DatePickerShow';
import { EmbedAppStatus } from './components/EmbedAppStatus';
import { WidgetPlaceManually } from './components/WidgetPlaceManually';

const WidgetPosition = () => {
  return (
    <BlockStack gap={'500'}>
      <EmbedAppStatus />
      <DatePickerShow />
      <WidgetPlaceManually />
    </BlockStack>
  );
};

export default WidgetPosition;
